import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'valueArray',
    standalone: false
})
export class ValueArrayPipe implements PipeTransform {
  // Transforma esto "[\"perro\"]" a esto ["perro"]
  transform(objects : any) {
    let parsed = objects;
    if (objects !== null && typeof objects === 'string' && objects.includes('[')) {
      try {
        parsed = JSON.parse(objects);
      } catch (e) {
        return objects;
      }
    }
    if (Array.isArray(parsed) && parsed.length && parsed.every(x => x && typeof x === 'object' && 'name' in x)) {
      return parsed
        .filter(x => x.value === true || x.value === 'true')
        .map(x => x.name)
        .filter(Boolean)
        .join('; ');
    }
    return parsed;
  }
}
